import type { TFunction } from 'i18next';
import { OrderStatus } from '../../modules/backend/openapi/api-types';

export const ORDER_STATUS_TRANSLATION_MAP: Record<OrderStatus, (t: TFunction) => string> = {
  ['UNKNOWN']: (t) => t('order.status.unknown'),
  ['RECEIVED']: (t) => t('order.status.received'),
  ['DELIVERED']: (t) => t('order.status.delivered'),
  ['PROCESSED']: (t) => t('order.status.processed'),
};
